import axios from "axios";

const convertData = ({
  inputData,
  inputDataType,
  templateCollectionReference,
  rootTemplate,
}) =>
  axios.post(`${process.env.FHIR_API_URL}/$convert-data`, {
    resourceType: "Parameters",
    parameter: [
      {
        name: "inputData",
        valueString: inputData,
      },
      {
        name: "inputDataType",
        valueString: inputDataType,
      },
      {
        name: "templateCollectionReference",
        valueString: templateCollectionReference,
      },
      {
        name: "rootTemplate",
        valueString: rootTemplate,
      },
    ],
  });

const fetch = () => axios.get("/api/v1/fhir_conversions");

const create = payload =>
  axios.post("/api/v1/fhir_conversions", { fhir_conversion: payload });

const fhirApi = {
  convertData,
  fetch,
  create,
};

export default fhirApi;
